if (document.readyState !== 'loading') {
    initAllScrollCarousels();
} else {
  document.addEventListener('DOMContentLoaded', function(event) {
    initAllScrollCarousels();
  });
}

function initAllScrollCarousels() {
  let carouselContainers = document.querySelectorAll('.css-carousel-container');
  for(let i = 0; i < carouselContainers.length; i++) {
    initScrollCarousel(carouselContainers[i]);
  }
}

function initScrollCarousel(container) {
  const slides = Array.from(container.querySelectorAll('.css-carousel__slide'));
  const nav = container.querySelector('.css-carousel__nav');
  const dots = nav && nav.querySelectorAll('.css-carousel__indicator').length > 0 ? Array.from(nav.querySelectorAll('.css-carousel__indicator')) : [];
  const index = container.querySelector('.css-carousel__index');
  const prevButton = container.querySelector('.css-carousel__action--prev');
  const nextButton = container.querySelector('.css-carousel__action--next');

  function getMostVisibleSlide() {
    const track = container.querySelector('.css-carousel');

    const viewportWidth = window.innerWidth;
    const trackLeft = track.getBoundingClientRect().left;
    const trackRight = track.getBoundingClientRect().right;

    let mostVisibleSlide = null;
    let maxVisiblePercentage = 0;

    slides.forEach((slide, index) => {
      const slideLeft = slide.getBoundingClientRect().left;
      const slideRight = slide.getBoundingClientRect().right;

      // Calculate the percentage of the slide that is within the viewport
      const visiblePercentage = Math.min(slideRight, trackRight) - Math.max(slideLeft, trackLeft);
      const totalSlideWidth = slideRight - slideLeft;
      const slidePercentage = (visiblePercentage / totalSlideWidth) * 100;

      if (slidePercentage > maxVisiblePercentage) {
        mostVisibleSlide = slide;
        maxVisiblePercentage = slidePercentage;
      }
    });

    return mostVisibleSlide;
  }


  // Update the active dot and the visible slide
  const updateActiveSlide = (currentSlide) => {
    if(dots.length === 0) {
      return
    }
    const currentDot = dots.find(dot => dot.classList.contains('active'));
    if (currentDot) {
      currentDot.classList.remove('active');
    }

    const newActiveDot = dots[slides.indexOf(currentSlide)];
    newActiveDot.classList.add('active');

    // Update index indicator
    if(index) {
      index.textContent = `${slides.indexOf(currentSlide) + 1}/${slides.length}`;
    }
  }

  // Initialize index indicator
  if(index) {
    index.textContent = `1/${slides.length}`;
  }

  const getScrollAmount = (targetSlide) => {
    return slides.slice(0, slides.indexOf(targetSlide)).reduce((totalWidth, slide) => totalWidth + slide.clientWidth, 0);
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
  }

  // Listen for scroll events on the track
  
  let overflowContainer = container.querySelector('.css-carousel');
  if(overflowContainer.getAttribute('listener') !== 'true') {
    overflowContainer.addEventListener('scroll', debounceHandleScroll);
    overflowContainer.setAttribute('listener', 'true');
  }

  function debounceHandleScroll() {
    debounce(handleScroll, 28);
  }

  function handleScroll() {
    console.log('scrolled');
    const currentSlide = slides.find(slide => {
      const slideLeft = slide.getBoundingClientRect().left;
      const trackLeft = overflowContainer.getBoundingClientRect().left;
      return slideLeft >= trackLeft;
    });
    console.log("current slide:", currentSlide);

    if (currentSlide) {
      const mostVisibleSlide = getMostVisibleSlide();
      console.log("The most visible slide is:", mostVisibleSlide);
      updateActiveSlide(mostVisibleSlide);
    }
  }

  // Listen for clicks on the dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetSlide = slides[index];
      // targetSlide.scrollIntoView({behavior: 'smooth', block:'nearest', inline: 'start'});
      const scrollAmount = getScrollAmount(targetSlide);
      overflowContainer.scrollLeft = scrollAmount;
      updateActiveSlide(targetSlide);
    });
  });

  if(prevButton) {
    prevButton.addEventListener('click', () => {
      const currentSlide = slides.find(slide => {
        const slideLeft = slide.getBoundingClientRect().left;
        const trackLeft = overflowContainer.getBoundingClientRect().left;
        return slideLeft >= trackLeft;
      });
      console.log("current slide:", currentSlide);

      if (currentSlide) {
        const currentSlideIndex = Number(currentSlide.dataset.slideIndex);
        console.log("current slide index: ", currentSlide.dataset.slideIndex);
        let targetSlideIndex = currentSlideIndex - 1;
        if(targetSlideIndex < 0) {
          targetSlideIndex = slides.length - 1;
        }
        const targetSlide = slides[targetSlideIndex];
        const scrollAmount = getScrollAmount(targetSlide);
        overflowContainer.scrollLeft = scrollAmount;
      }
    });
  }

  if(nextButton) {
    nextButton.addEventListener('click', () => {
      const currentSlide = slides.find(slide => {
        const slideLeft = slide.getBoundingClientRect().left;
        const trackLeft = overflowContainer.getBoundingClientRect().left;
        return slideLeft >= trackLeft;
      });

      if (currentSlide) {
        const currentSlideIndex = Number(currentSlide.dataset.slideIndex);
        console.log("current slide index: ", currentSlideIndex);
        let targetSlideIndex = currentSlideIndex + 1;
        if(targetSlideIndex === slides.length) {
          targetSlideIndex = 0;
        }
        const targetSlide = slides[targetSlideIndex];
        const scrollAmount = getScrollAmount(targetSlide);
        overflowContainer.scrollLeft = scrollAmount;
      }
    });
  }

  

}